<template>
  <a-result status="404" title="404" sub-title="页面不存在 , 或没有权限 。">
    <template #extra>
      <a-button type="primary" @click="gohome">返回首页</a-button>
      <!--      <a-button type="primary" @click="gohome">返回首页</a-button>
            <a-button type="dashed" @click="goback">返回上一页</a-button>-->
    </template>
  </a-result>
</template>
<script name="Page404">
import * as sso from '@/utils/sso'
import {_defaultIndex, getIndexPage} from "elead-ui-tool-v3";
import {tool} from 'elead-ui-tool-v3'
export default {
  mounted() {
    // localStorage.clear()
    // sso.toLogin()
  },
  methods: {
    gohome() {
      getIndexPage({
        menu: tool.data.get('MENU'),
        success: (_defaultIndex) => {
          this.$router.replace({
            path: _defaultIndex.cur.path
          })
        }
      })
    },
    goback() {
      this.$router.go(-1)
    }
  }
}
</script>
